// extracted by mini-css-extract-plugin
export default {"header":"AppBar_header__kF0IS"};